import React, { useState, FC } from 'react';
import { ToggleComponent } from 'src/common/form/toggle/component';
import { JourneyMenuPropsInterface } from 'src/common/JourneyMenu';
import { SmallPanel } from 'src/common/ui/small-panel';

interface DashboardHomeStatusPanelProps
  extends Pick<
    JourneyMenuPropsInterface,
    'openRef' | 'closeRef' | 'renderOrigin' | 'onOpen' | 'onClose' | 'placement'
  > {
  onChange: (checked: string) => void;
  isEnabled: boolean;
  onBack: () => void;
}

export const DashboardHomeStatusPanel: FC<DashboardHomeStatusPanelProps> = ({
  onChange,
  isEnabled,
  onBack,
  children,
  ...popoverProps
}) => {
  const [isStatusEnabled, setIsStatusEnabled] = useState(isEnabled);

  const onStatusChanged = (checked: boolean) => {
    setIsStatusEnabled(checked);
    onChange(checked ? 'public' : 'draft');
  };

  return (
    <SmallPanel openAfterMount hasBackButton onBack={onBack} {...popoverProps}>
      <div className='flex flex-col space-y-md'>
        <ToggleComponent
          checked={isStatusEnabled}
          onChange={onStatusChanged}
          label={isStatusEnabled ? 'Published' : 'Draft'}
          isNeue={true}
        />
      </div>
    </SmallPanel>
  );
};
